import { Box } from '@mui/material';
import ChatFlow from 'components/@home/@settings/Tabs/ChatFlow';
import ChatFlowEntityType from 'components/@home/@settings/Tabs/ChatFlowEntityType';
import ChatFlowEntryFulfillment from 'components/@home/@settings/Tabs/ChatFlowEntryFulfillment';
import SkillEditor from 'components/@home/@settings/Tabs/Agents/SkillEditor';
import ToolEditor from 'components/@home/@settings/Tabs/Agents/ToolEditor';
import ChatFlowIntegration from 'components/@home/@settings/Tabs/ChatFlowIntegration';
import ChatFlowIntent from 'components/@home/@settings/Tabs/ChatFlowIntent';
import ChatFlowPage from 'components/@home/@settings/Tabs/ChatFlowPage';
import ChatFlowRoute from 'components/@home/@settings/Tabs/ChatFlowRoute';
import ChatFlowTest from 'components/@home/@settings/Tabs/ChatFlowTest';
import React, { useEffect, useState } from 'react';
import { object, string } from 'prop-types';

const RightPane = ({
  context = null,
  chatFlows = null,
  chatFlowEntityTypes = null,
  chatFlowIntents = null,
  chatFlowIntegrations = null,
  selectedFlow = null,
}) => {
  const [selectedIntent, setSelectedIntent] = useState(null);
  const [selectedIntegration, setSelectedIntegration] = useState(null);
  useEffect(() => {
    setSelectedIntent(null);
    setSelectedIntegration(null);
  }, [context.current?.route]);

  let pane = null;
  switch (context.current?.type) {
    case 'flow': {
      const flowId = context.current?.flow;
      const flow =
        chatFlows[flowId] ||
        (flowId === 'new' ? { _id: 'new', mode: context.current?.flowMode || 'pages' } : undefined);
      pane = <ChatFlow flow={flow} />;
      break;
    }
    case 'entity-type':
      pane = <ChatFlowEntityType entityType={chatFlowEntityTypes[context.current?.entityType]} />;
      break;
    case 'intent':
      pane = <ChatFlowIntent intent={chatFlowIntents[context.current?.intent]} />;
      break;
    case 'entry-fulfillment':
      pane = <ChatFlowEntryFulfillment key={context.current.page} flow={chatFlows[selectedFlow]} />;
      break;
    case 'test':
      pane = <ChatFlowTest flow={chatFlows[selectedFlow]} />;
      break;
    case 'route':
      pane = (
        <ChatFlowRoute
          key={context.current.route}
          selectedIntent={selectedIntent}
          selectedIntegration={selectedIntegration}
          flow={chatFlows[selectedFlow]}
          setSelectedIntent={setSelectedIntent}
          setSelectedIntegration={setSelectedIntegration}
          chatFlowIntents={chatFlowIntents}
          chatFlowIntegrations={chatFlowIntegrations}
        />
      );
      break;
    case 'page':
      pane = <ChatFlowPage flow={chatFlows[selectedFlow]} />;
      break;
    case 'integration':
      pane = (
        <ChatFlowIntegration integration={chatFlowIntegrations[context.current?.integration]} />
      );
      break;
    case 'skill': {
      const skillId = context.current?.skill;
      if (skillId !== 'new') pane = <SkillEditor skillId={skillId} />;
      break;
    }
    case 'agent-tool': {
      const toolId = context.current?.agentTool;
      if (toolId !== 'new') pane = <ToolEditor toolId={toolId} />;
      break;
    }
    default:
      break;
  }

  if (!pane) return null;

  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        '& > *': { flex: 1, minHeight: 0 },
      }}
    >
      {pane}
    </Box>
  );
};

RightPane.propTypes = {
  context: object,
  chatFlows: object,
  chatFlowEntityTypes: object,
  chatFlowIntents: object,
  chatFlowIntegrations: object,
  selectedFlow: string,
};

export default RightPane;
